import { useState } from 'react';

import { Text } from '@mantine/core';

import { IconSearch } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { MultiCheckbox } from '../../../shared/components/UI/MultiCheckbox/MultiCheckbox';
import { TextInput } from '../../../shared/components/UI/TextInput/TextInput';

import { Role } from '../../../shared/entities/Access';
import { useFilters } from '../hooks/useFilters.hook';

export function RoleSelect() {
  const { t } = useTranslation(['entities', 'workspaceSettings']);
  const { roles, setRoles } = useFilters();

  const label =
    roles.length > 0
      ? roles.map(role => t(`role.${role}`)).join(', ')
      : t('workspaceSettings:filters.role');

  const options = [
    {
      value: Role.ADMINISTRATOR,
      label: <Text>{t('role.ADMINISTRATOR')}</Text>,
    },
    {
      value: Role.DECISION_MAKER,
      label: <Text>{t('role.DECISION_MAKER')}</Text>,
    },
    {
      value: Role.CONTRIBUTOR,
      label: <Text>{t('role.CONTRIBUTOR')}</Text>,
    },
  ];

  return (
    <MultiCheckbox
      label={label}
      values={roles.map(role => ({
        value: role,
        label: <Text>{t(`role.${role}`)}</Text>,
      }))}
      options={options}
      onChange={newVals => setRoles(newVals.map(({ value }) => value as Role))}
    />
  );
}

export function SearchInput() {
  const { search, setSearch } = useFilters();

  const { t } = useTranslation('workspaceSettings');
  const [isFocused, setIsFocused] = useState(false);

  return (
    <TextInput
      variant="filled"
      w={isFocused ? `300px` : `200px`}
      placeholder={t('filters.search')}
      icon={<IconSearch />}
      value={search}
      onChange={e => {
        setSearch(e.target.value);
      }}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      sx={{ transition: 'width 0.5s' }}
    />
  );
}
